<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column">
      <h3 class="is-size-3">
        {{ middleware.name }}
      </h3>
      <p>{{ middleware.class }}</p>
    </div>
  </div>

  <div class="columns" v-if="middleware.type.id">
    <div class="column">
      <div class="box">
        This middleware is classified as an <span class="has-text-danger">{{ middleware.type.type }}</span> middleware. {{ middleware.type.description }}
        <br>
        <a v-if="!middleware.type.is_default" @click="removeClassification">Remove classification</a>
      </div>
    </div>
  </div>
  
  <div class="columns" v-else>
    <div class="column">
      <div class="box">
        <h5 class="title is-5 has-text-danger">Unclassified Middleware</h5>
        <form>
          <div class="columns">
            <div class="column">
              <select-input
                required
                :items="middlewareTypes"
                v-model="classification.middleware_type_id"
                :error="$root.errorBag.middleware_type_id"
                label-key="purpose"
                value-key="id">Classify Middleware</select-input>

              <p class="help" v-if="activeType">{{ activeType.description }}</p>  
            </div>
          </div>
          <div class="columns" v-if="activeType && activeType.type === 'idor'">
            <div class="column">
              <data-selector
                required
                multiple
                :items="modelBindingsList"
                v-model="classification.bindings"
                :error="$root.errorBag.bindings"
                label-key="class"
                value-key="id">Models</data-selector>

              <p class="help" v-if="activeType">{{ activeType.description }}</p>  
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <submit-button :disabled="!$root.can('classify_middleware', environment.app.account_id)" @submit="classify">Save</submit-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <div class="columns" v-if="middleware.type && middleware.type.type === 'idor'">
    <div class="column">
      <div class="columns">
        <div class="column">
          <h4 class="is-size-4">Model Protection</h4>
          This middleware class is protecting {{ middleware.bindings.length }} model<span v-if="middleware.bindings.length !== 1">s</span> from IDOR attacks.
        </div>
        <div class="column is-narrow">
          <action-button @click="addModels" class="is-rounded">Add Models</action-button>
        </div>
      </div>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>Model</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="binding in middleware.bindings" :key="binding.id">
            <td>{{ binding.class_name }}</td>
            <td class="is-narrow">
              <action-button @click="removeModel(binding)" left-icon="trash" class="is-small is-danger is-rounded">Remove</action-button>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="has-text-centered has-text-danger" v-if="!middleware.bindings.length">No Models Found</p>
    </div>
  </div>
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'
import { addModelsToMiddleware } from '@/modals'
import { get, post } from '@/api/request'
import { find } from 'lodash'

export default {
  
  data: () => ({
    loading: true,
    middlewareTypes: [],
    classification: {
      middleware_type_id: '',
      bindings: []
    }
  }),

  beforeCreate() {
    Promise.all([
      this.$store.dispatch('middleware/loadMiddleware', {
        middlewareId: this.$route.params.middleware,
        envId: this.$route.params.environment,
      }),
      get('/api/middleware-types', ({data}) => {
        this.middlewareTypes = data
      }),
      this.$store.dispatch('environment/loadModelBindingsList', this.$route.params.environment)
    ]).then(() => {
      this.loading = false
    })
  },

  methods: {
    addModels() {
      addModelsToMiddleware(this.middleware)
    },
    async removeModel(model) {
      if(await this.$confirm({
        title: 'Remove Model',
        message: 'Are you sure you want to remove this model?'
      })) {
        this.$store.dispatch('middleware/removeBinding', model.id).then(() => {
          this.$toast.success('Model removed')
        })
      }
    },
    classify() {
      let classification = { 
        middleware_type_id: this.classification.middleware_type_id,
        route_bindings: this.classification.bindings.map(binding => binding.id)
      }
      post(`/api/middleware/${this.middleware.id}/classify`, classification, ({data}) => {
        this.$toast.success('Middleware classified')
        this.$store.commit('middleware/setType', this.activeType)
        this.$store.commit('middleware/setMiddleware', data)
      }, error => {

      })
    },
    async removeClassification() {
      if(await this.$confirm({
        title: 'Remove Classification',
        message: 'Are you sure you want to remove this classification? All routes currently associated with this classification will be reassessed'
      })) {
        this.$store.dispatch('middleware/declassify').then(() => {
          this.$toast.success('Middleware declassifed')
        })
      }
    }
  },

  computed: {
    ...mapGetters('middleware', [
      'middleware'
    ]),
    ...mapGetters('environment', [
      'environment',
      'modelBindingsList'
    ]),
    activeType() {
      return find(this.middlewareTypes, type => type.id === this.classification.middleware_type_id)
    }
  }

}
</script>